import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Auth0Provider } from '@auth0/auth0-react';
import { HeroUIProvider } from '@heroui/react';
import App from './App.tsx';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { AppErrorBoundary } from '@/components/ErrorBoundary';
import { queryClient } from '@/lib/queryClient';
import { initDatadog } from '@/services/datadog';
import '@/i18n';
import './index.css';

// Initialize Datadog RUM before React renders (only in staging/production)
initDatadog();

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN || '';
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID || '';
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE || '';
const auth0Connection = import.meta.env.AUTH0_MICROSOFT_CONNECTION || '';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Auth0Provider
          domain={auth0Domain}
          clientId={auth0ClientId}
          authorizationParams={{
            audience: auth0Audience,
            redirect_uri: window.location.origin + '/callback',
            connection: auth0Connection,
          }}
        >
          <HeroUIProvider>
            <ThemeProvider>
              <LanguageProvider>
                <AuthProvider>
                  <AppErrorBoundary>
                    <App />
                  </AppErrorBoundary>
                </AuthProvider>
              </LanguageProvider>
            </ThemeProvider>
          </HeroUIProvider>
        </Auth0Provider>
      </BrowserRouter>
      {/* <ReactQueryDevtools initialIsOpen={false} /> enable if you want to see the query devtools` */}
    </QueryClientProvider>
  </React.StrictMode>,
);
